import * as React from "react"
import i18next from 'i18next'

export type Pager = {
  currentPage: number
  totalItems: number
  totalPages: number
  itemsPerPage: number
}

type PaginationState = {}
type PaginationProps = {
  pager: Pager
  setPage: (page: number) => void,
  getUrlToPage: (page: number) => string,
}

export class Pagination extends React.Component<PaginationProps, PaginationState> {
  constructor(props:any) {
    super(props)
  }

  render() {
    const { pager, setPage, getUrlToPage } = this.props
    const { currentPage, totalPages } = pager
    const labelCurrentpage = (currentPage + 1)

    return totalPages > 1 ? (
      <nav className="pager" aria-label={i18next.t('Pager:LabelA11Y')}>
        <ul className="pager__list ls-container ls-spacing ls-gutter">
          {currentPage > 0 ? (
            <li className="pager__item pager__item--prev">
              <a className="pager__prev button button--primary" 
              href={getUrlToPage(currentPage - 1)}
              onClick={e => {
                e.preventDefault()
                setPage(currentPage - 1)
                }}>
                <span className="button__label">{i18next.t('Pager:previous')}</span> 
              </a>
            </li>
          ) : (
            <li className="pager__item pager__item--prev">
              <button className="pager__prev button button--primary" disabled>
                <span className="button__label">{i18next.t('Pager:previous')}</span>
              </button>
            </li>
          )}

          <li className="pager__status text--s" aria-hidden="true">
            <span className="pager__current">
              <em>{labelCurrentpage}</em>
              <span>/</span>
              {totalPages}
            </span>
          </li>

          {currentPage < totalPages - 1 ? (
            <li className="pager__item pager__item--next">
              <a className="pager__next link button button--primary" 
              href={getUrlToPage(currentPage + 1)}
              onClick={e => {
                e.preventDefault()
                setPage(currentPage + 1)
                }}>
                <span className="button__label">{i18next.t('Pager:next')}</span>
              </a>
            </li>
          ) : (
            <li className="pager__item pager__item--next">
              <button className="pager__next button button--primary" disabled>
                <span className="button__label">{i18next.t('Pager:next')}</span>
              </button>
            </li>
          )}
        </ul>
      </nav>
    ) : null
  }
}
